import IComponent from "components/commons/IComponent";
import "./SpotElevation.scoped.css";
// import Button from "@material-ui/core/Button";
import EditableDatagridCell from "components/commons/EditableDatagridCell";
import "./PanelBase.scoped.css";
import * as geoprocessor from "@arcgis/core/rest/geoprocessor.js";
import DivTable from "components/commons/DivTable";

class SpotElevations extends IComponent {
  constructor(props) {
    super(props);
    this.state = {
      Output_data: undefined,
      isLoading: false,
    };
  }
  componentDidMount() {
    this.ProcessSpotElevation();
    this.props.mapUICallback("DisaleAllWhenShowPanel");
  }
  componentWillUnmount() {}

  async ProcessSpotElevation() {
    try {
      this.setState({ isLoading: true });
      let url = this.$config.gpToolUrls.PointElevation;
      let params = this.props.params;
      let options = {
        userProxy: this.$config.useEsriProxy,
      };

      let processR = await geoprocessor.execute(
        url,
        params,
        undefined,
        options
      );
      // Get the result with either fetchResultData(), fetchResultImage(), or fetchResultMapImageLayer();
      let Output_data = processR.results[0].value.features.map(
        (value, index) => {
          return {
            Distance: value.attributes.Distance,
            Height: value.attributes.Height,
          };
        }
      );
      this.setState({ Output_data: Output_data, isLoading: false });
    } catch (e) {
      this.props.showDialog({
        isOpen: true,
        type: "error",
        title: "Failed to submit your feature nos",
        content: "Error occurred when submiting your feature nos",
        jsxElement: e.toString(),
        onDialogOk: () => {},
      });
    }

    // result.fetchResultData();
    // result.fetchResultImage();
    // result.fetchResultMapImageLayer();
  }

  render() {
    let { Output_data, isLoading } = this.state;
    return (
      <div>
        <div className="PanelBaseTitle EqualWidthChildren">
          <span>Elevation of Nearest Five Points</span>
          <div />
          <span
            className="icn_3d_Elevationprofile_close CloseButton"
            onClick={() => this.props.mapUICallback("hideAllPanel")}
          />
        </div>

        <div className="PanelContent">
          <div style={{ height: "350px" }}>
            <DivTable
              data={Output_data}
              columnDef={[
                {
                  name: "Distance (m)",
                  value: "Distance",
                },
                {
                  name: "Elevation (mPD)",
                  value: "Height",
                },
              ]}
              noDataText={function() {
                if (isLoading)
                  return (
                    <div className="SubPanelContent">
                      <div>
                        <span className="icn_loading" /> Refreshing your feature
                        distribution..
                      </div>
                      <div
                        style={{
                          textAlign: "center",
                          padding: "10px",
                        }}
                      >
                        ***Close the window to cancel process***
                      </div>
                    </div>
                  );
              }.apply(this)}
            />
          </div>
        </div>
      </div>
    );
  }
}

export default SpotElevations;
